import React, { useContext, useEffect } from 'react';

import Autocomplete from '../components/InputLink';
import TemplateSelect from '../components/TemplateInputLink';

import { Store } from '../data/Store';
import { loadTemplate, selectsection, fetchPedigreeAction, updateLocalData } from '../data/Actions';

import { Button } from 'antd';
import 'antd/dist/antd.css';

import styled from 'styled-components';

import { Pedigree } from '../data/pedigree';

let currentPedigree = "";

function FieldGroup(props) {
    const { state, dispatch } = useContext(Store);
    const childrenWithProps = React.Children.map(props.children, child => {
        return child;
    });
    
    const filteredChildren = childrenWithProps.filter((child) => {
        return (child.props.hasOwnProperty('name')
            && child.props.hasOwnProperty('label'));
    });
    
    useEffect(() => {
        if (props.hasOwnProperty('handlenext')) props.handlenext(filteredChildren);
    }, [props]);
    
    function buildPath(keys, key, obj) {
        keys = `${keys}.${key}`;

        return keys.split('.').reduce((o,i)=>{
            return (Array.isArray(o)) ? o[parseInt(i)] : o[i];
        }, obj);
    }
    
    function handleInput(inputRef) {
        let childInputs = props.children
            .filter(filterChildren)
            .map(mapChildren);
        
        function filterChildren(child) {
            return (child.props.hasOwnProperty('name') 
            && child.props.hasOwnProperty('label'));
        }

        function mapChildren(child) {
            let name = child.props.name;
            let childProps = child.props;
            return {...childProps, 'autoValue': buildPath([name], 'auto', state)[0]};
        }
        
        selectsection(childInputs, state, dispatch);
    }

    function handleKeyDown(e) {
        var charCode = e.keyCode || e.which;
    }

    function handleKeyUp(e) {
         e = e || window.event;
        var charCode = e.keyCode || e.which;
        
        let keys = props.children.map((input) => {
            return input.props;
        });
    }
    
    function handleKeyPress(e) {
        e = e || window.event;
        var charCode = e.keyCode || e.which;
    }
    
    return (<div onKeyPress={handleKeyPress}
                onKeyDown={handleKeyDown}
                onKeyUp={handleKeyUp}
                className={props.className}>
                {childrenWithProps}
            </div>);
}

function PedigreeWrap(props) {
    const children = [];
    function handlenext(data) {
        children.push([...data]);
    }

    const childrenWithProps = React.Children.map(props.children, child => {
        const props = { handlenext };
        if (React.isValidElement(child)) {
            return React.cloneElement(child, props);
        }
        return child;
    });
    return (<div handlenext={handlenext} className={props.className}>{childrenWithProps}</div>);
}

function Distributors(props) {
    const deleteDist = (i, state, dispatch) => {
        state.Pedigree.Distributors.splice(i, 1);

        const path = { key: 'Pedigree.Distributors', value: state.Pedigree.Distributors };
        updateLocalData(path, state, dispatch);
    };
    const addDist = (state, dispatch) => {
        const distributorTemplate = JSON.parse(JSON.stringify(Pedigree.Distributors[0]));
        state.Pedigree.Distributors.push(distributorTemplate);

        const path = { key: 'Pedigree.Distributors', value: state.Pedigree.Distributors };
        updateLocalData(path, state, dispatch);
    };

    const DistributorsList = props.state.Pedigree.Distributors.map((dist, i) => {
        return (<StyledFieldGroup handlenext={props.handlenext}>
                    <Autocomplete name={`Pedigree.Distributors.${i}.Invoice`} label="Invoice No." />
                	<Autocomplete name={`Pedigree.Distributors.${i}.TransactionDate`} label="Transaction Date" type="date" />
                	<Autocomplete name={`Pedigree.Distributors.${i}.Name`} label="Name" />
                	<Autocomplete name={`Pedigree.Distributors.${i}.Address`} label="Address" />
                	<Autocomplete name={`Pedigree.Distributors.${i}.City`} label="City" />
                	<Autocomplete name={`Pedigree.Distributors.${i}.State`} label="State" />
                	<Autocomplete name={`Pedigree.Distributors.${i}.Zip`} label="Zip" />
                	<ButtonRight>
                	    <button className={'delete'} onClick={()=>deleteDist(i, props.state, props.dispatch)}>delete</button>
            	    </ButtonRight>
        	    </StyledFieldGroup>);
    });
    return <div><button className={'add'} onClick={()=>addDist(props.state, props.dispatch)}>Add Distributor</button>{DistributorsList}</div>;
}
const StyledTemplateSearch = styled(TemplateSearch)`
    display: grid;
    grid-template: 1fr / auto auto 75px;
    @media (max-width:500px) {
        grid-template: 1fr 1fr 1fr / auto;
        padding: 0 15px 10px 15px;
        input {
            height: 32px;
            width: 100%;
            max-width: none!important;
        }
    }
    input {
        height: 32px;
        width: 100%;
        max-width: 140px;
    }
    span {
        
    }
`;
const TransactionInfo = styled.div`
    display: grid;
    grid-template: 1fr / 155px 1fr;
    @media (max-width:600px) {
        grid-template: auto auto / 1fr;
    }
`;
const StyledButton = styled(Button)`
    pointer-event: none;
    cursor: not-allowed;
    font-weight: 600;
    &:hover, :active, :focus {
        border: none;
        color: black;
    }
    &[view="active"] {
        pointer-event: auto;
        cursor: auto;
        border: 1px solid green;
        background-color: green;
        color: white;
    }
`;

function TemplateSearch(props) {
    return(<div className={props.className}>
                {props.children}
            </div>);
}

const ButtonRight = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StyledFieldGroup = styled(FieldGroup)`
    background-color: #f4f4f8;
    padding: 15px;
    margin: 0 0 10px 0;
    input {
        &::-webkit-input-placeholder { /* Edge */
          color: #158fa9;
        }
        &::-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: #158fa9;
        }
        &::placeholder {
          color: #158fa9;
        }
    }
`;

const StyledPedigreeWrap = styled(PedigreeWrap)`
    background-color: #d7d7e5;
    padding: .7vw;
    max-width: 700px;
    margin: 0 auto;
    input {
        border: 1px solid rgb(199 197 197);
        padding-left: 10px;
        margin-bottom: 4px;
        border-radius: 3px;
    }
    button.add {
        margin-bottom: 5px;
    }
    button.delete {
        margin-top: 5px;
        float: right;
    }
    h4 {
        font-size: inherit;
    }
`;

export default function PedigreePage(props) {
    const { state, dispatch } = useContext(Store);

    useEffect(() => {
        if (props.pedigree !== currentPedigree) {
            fetchPedigreeAction(props.pedigree, state, dispatch);
            currentPedigree = props.pedigree;
            // state.Pedigree.id.value = props.pedigree;
            state.Template.ItemId.value = '';
            state.Template.LotId.value = '';
        }
    }, [state, dispatch]);

    function templateSelectClick(e) {
        loadTemplate(state, dispatch);
    }

    return (<>
        {(state.PedType === 'TEMP') ?
        (<div>
        <br />
        <br />
        <br />
        <h3 style={{'text-align':'center', 'padding-bottom':'5px', 'color': '#013b73'}}>Product Template</h3>
        <StyledPedigreeWrap>
            <StyledFieldGroup>
                <Autocomplete name={'Pedigree.TransactionDate'} label="Transaction Date" lock="true" type="date" />
            </StyledFieldGroup>
            <br></br>
            <TransactionInfo>
                <h4>Transaction Info:</h4>
                <StyledTemplateSearch>
                    <TemplateSelect name="Template.ItemId" label="Item Number" />
                    <TemplateSelect name="Template.LotId" label="Lot ID" />
                    <StyledButton view={
                            (state.Template.match) ? 'active' : ''    
                        } onClick={templateSelectClick}>Select</StyledButton>
                </StyledTemplateSearch>
            </TransactionInfo>
            <StyledFieldGroup>
                <Autocomplete name="Pedigree.Transaction.Product" label="Product" />
            	<Autocomplete name="Pedigree.Transaction.ItemId" label="Item Number" />
            	<Autocomplete name="Pedigree.Transaction.Strength" label="Strength" />
            	<Autocomplete name="Pedigree.Transaction.DoseForm" label="Dose Form" />
            	<Autocomplete name="Pedigree.Transaction.ContainerSize" label="Container Size" />
            	<Autocomplete name="Pedigree.Transaction.LotId" label="Lot ID" />
            	<Autocomplete name="Pedigree.Transaction.LotExp" label="Lot Expiration Date" type="date" />
            	<Autocomplete name="Pedigree.Transaction.Quantity" label="Quantity" />
            </StyledFieldGroup>
            <br></br>
            <h4>Transaction History</h4>
            <StyledFieldGroup>
                <p>Manufacturer Info:</p>
                <Autocomplete name="Pedigree.Manufacturer.Name" label="Name" />
            	<Autocomplete name="Pedigree.Manufacturer.Address" label="Address" />
            	<Autocomplete name="Pedigree.Manufacturer.City" label="City" />
            	<Autocomplete name="Pedigree.Manufacturer.State" label="State" />
            	<Autocomplete name="Pedigree.Manufacturer.Zip" label="Zip" />
            	<Autocomplete name="Pedigree.Manufacturer.BulkLotId" label="Bulk Lot Number" />
            	<Autocomplete name="Pedigree.Manufacturer.Exp" label="Expiration Date" type="date" />
            	<Autocomplete name="Pedigree.Manufacturer.ContainerSize" label="Container Size" />
            	<Autocomplete name="Pedigree.Manufacturer.NDC" label="NDC number" />
            	<Autocomplete name="Pedigree.Manufacturer.Invoice" label="Manufactured By" />
            	{/*<Autocomplete name="Pedigree.Manufacturer.Invoice" label="Invoice No. if provided." />*/}
            	{/*<Autocomplete name="Pedigree.Manufacturer.TransactionDate" label="Transaction Date" type="date" />*/}
    	    </StyledFieldGroup>
    	    <br></br>
    	    <p>Distributor</p>
    	    <Distributors state={state} dispatch={dispatch} handlenext={props.handlenext} />
        </StyledPedigreeWrap>
        <br />
        <br />
        <br />
        </div>) :
        
        (<div>
        <br />
        <br />
        <br />
        <h3 style={{'text-align':'center', 'padding-bottom':'5px', 'color': '#013b73'}}>DRUG SUPPLY CHAIN SECURITY ACT DOCUMENT</h3>
        <StyledPedigreeWrap>
            <h4>Client Info:</h4>
            <StyledFieldGroup>
                <Autocomplete name={'Pedigree.IssuedTo'} label="Issued To" />
                <Autocomplete name={"Pedigree.ClientId"} label="Client Id" />
                <Autocomplete name={'Pedigree.Invoice'} label="Invoice Number" lock="true" />
                <Autocomplete name={'Pedigree.TransactionDate'} label="Transaction Date" lock="true" type="date" />
            </StyledFieldGroup>
            <br></br>
            <TransactionInfo>
                <h4>Transaction Info:</h4>
                <StyledTemplateSearch>
                    <TemplateSelect name="Template.ItemId" label="Item Number" />
                    <TemplateSelect name="Template.LotId" label="Lot ID" />
                    <StyledButton view={
                            (state.Template.match) ? 'active' : ''    
                        } onClick={templateSelectClick}>Select</StyledButton>
                </StyledTemplateSearch>
            </TransactionInfo>
            <StyledFieldGroup>
                <Autocomplete name="Pedigree.Transaction.Product" label="Product" />
            	<Autocomplete name="Pedigree.Transaction.ItemId" label="Item Number" />
            	<Autocomplete name="Pedigree.Transaction.Strength" label="Strength" />
            	<Autocomplete name="Pedigree.Transaction.DoseForm" label="Dose Form" />
            	<Autocomplete name="Pedigree.Transaction.ContainerSize" label="Container Size" />
            	<Autocomplete name="Pedigree.Transaction.LotId" label="Lot ID" />
            	<Autocomplete name="Pedigree.Transaction.LotExp" label="Lot Expiration Date" type="date" />
            	<Autocomplete name="Pedigree.Transaction.Quantity" label="Quantity" />
            </StyledFieldGroup>
            <br></br>
            <h4>Transaction History</h4>
            <StyledFieldGroup>
                <p>Manufacturer Info:</p>
                <Autocomplete name="Pedigree.Manufacturer.Name" label="Name" />
            	<Autocomplete name="Pedigree.Manufacturer.Address" label="Address" />
            	<Autocomplete name="Pedigree.Manufacturer.City" label="City" />
            	<Autocomplete name="Pedigree.Manufacturer.State" label="State" />
            	<Autocomplete name="Pedigree.Manufacturer.Zip" label="Zip" />
            	<Autocomplete name="Pedigree.Manufacturer.BulkLotId" label="Bulk Lot Number" />
            	<Autocomplete name="Pedigree.Manufacturer.Exp" label="Expiration Date" type="date" />
            	<Autocomplete name="Pedigree.Manufacturer.ContainerSize" label="Container Size" />
            	<Autocomplete name="Pedigree.Manufacturer.NDC" label="NDC number" />
            	<Autocomplete name="Pedigree.Manufacturer.Invoice" label="Manufactured By" />
            	{/*<Autocomplete name="Pedigree.Manufacturer.Invoice" label="Invoice No. if provided." />*/}
            	{/*<Autocomplete name="Pedigree.Manufacturer.TransactionDate" label="Transaction Date" type="date" />*/}
    	    </StyledFieldGroup>
    	    <br></br>
    	    <p>Distributor</p>
    	    <Distributors state={state} dispatch={dispatch} handlenext={props.handlenext} />
    	    <br></br>
    	    <StyledFieldGroup>
                <p>Wholesale Distributor Info:</p>
            	<Autocomplete name="Pedigree.PurchaseDate" label="Transaction Date" type="date" />
    	    </StyledFieldGroup>
        </StyledPedigreeWrap>
        <br />
        <br />
        <br />
        </div>)}
    </>);
}


